export default __webpack_public_path__ + "static/media/mygudangn.4c0783c5.jpg";